export default {"src":"/_next/static/media/message-chat-circle.d9dee104.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};